import { render } from "./PlayerCard.vue?vue&type=template&id=a7bc22d6&scoped=true"
import script from "./PlayerCard.vue?vue&type=script&lang=js"
export * from "./PlayerCard.vue?vue&type=script&lang=js"

import "./PlayerCard.vue?vue&type=style&index=0&id=a7bc22d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7bc22d6"]])

export default __exports__